import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Button, useTheme, alpha } from '@mui/material';

interface DashedBtnProps {
  label: string;
  classes?: string;
  onClick?: () => void;
}

function DashedBtn(props: DashedBtnProps): JSX.Element {
  const theme = useTheme();

  return (
    <Button
      fullWidth
      variant="outlined"
      onClick={props.onClick}
      startIcon={<AddIcon />}
      sx={{
        borderStyle: 'dashed',
        borderWidth: '1.5px',
        borderColor: 'divider',
        borderRadius: '10px',
        color: 'text.secondary',
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.875rem',
        py: 1.2,
        bgcolor: alpha(theme.palette.grey[500], 0.02),
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          borderStyle: 'dashed',
          borderWidth: '1.5px',
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
          bgcolor: alpha(theme.palette.primary.main, 0.04),
        },
      }}
    >
      {props.label}
    </Button>
  );
}

export default DashedBtn;
